module.exports = __webpack_public_path__ + "static/img/brand-04.c18498b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand-04.png
// module id = ycdQ
// module chunks = 1